import React from 'react'
import './showsCategorySidebar.css'

const categoryData = ["Business","Education","Leisure"]

const ShowsCategory = () => {
  return (
    <div className='shows-category__container'>
      <div className='heading'>
        PODCASTS AVAILABLE FROM
      </div>
      <div className='category-list'>
        {categoryData.map(category=>(
            <div className='list-items'>
                <div className='bullet-icon'>
                    o
                </div>
                <div className='category-name'>
                    {category}
                </div>
            </div>
        ))}
      </div>
    </div>
  )
}

export default ShowsCategory
